<template>
  <v-dialog :value="value" :width="dialogWidth">
    <v-card class="px-5 pt-5 pb-2 dialog-container">
      <h2 class="dialog-title">{{ title }}</h2>
      <div v-if="hasDescription" class="mt-1 mb-5">
        <span class="dialog-description"> {{ description }} </span>
      </div>
      <mf-search v-model="search" hide-details :placeholder="searchPlaceholder" dense />
      <v-data-table
        :item-key="itemKey"
        class="mt-5"
        :headers="headers"
        :items="items"
        disable-pagination
        calculate-widths
        hide-default-footer
        :loading="loading"
        :search="search"
      >
        <template v-slot:[`item.select`]="{ item }">
          <div>
            <v-checkbox
              class="mt-0"
              :input-value="isSelectedItem(item)"
              color="primary"
              hide-details
              :disabled="!item.isSelectable || disableItemsSelection"
              @change="selectItem(item)"
            />
          </div>
        </template>
        <template v-slot:[`item.image`]="{ item }">
          <div class="img-container d-flex align-center justify-center">
            <img v-if="item.image && item.image.length" :src="item.image" alt="" width="100%" />
            <mf-icon v-else>image_not_supported</mf-icon>
          </div>
        </template>
        <template v-if="useLink" v-slot:[`item.name`]="{ item }">
          <a class="link" @click="link(item.sku)">
            <mf-tooltip top max-width="350px">
              <template v-slot:activator="{ on }">
                {{ item.name | truncate({ length: 40 }) }}
              </template>
              <span>{{ item.name }}</span>
            </mf-tooltip>
          </a>
        </template>
      </v-data-table>
      <v-card-actions class="dialog-actions">
        <mf-button label="Fechar" text-transform="none" color="marca-0-l10" depressed class="mt-2" @click="close"></mf-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ChipListDialog',
  props: {
    value: Boolean,
    title: {
      type: String,
      default: 'Lojas participantes',
    },
    description: {
      type: String,
      default: '',
    },
    searchPlaceholder: {
      type: String,
      default: 'Lojas participantes',
    },
    items: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    useLink: {
      type: Boolean,
      default: false,
    },
    linkUrl: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disableItemsSelection: {
      type: Boolean,
      default: false,
    },
    selectedItemsLimit: {
      type: Number,
      default: 0,
    },
    dialogWidth: {
      type: String,
      default: '515px',
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    itemKey: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    search: '',
  }),
  computed: {
    hasDescription() {
      return this.description?.length > 0
    },
    localSelectedItems: {
      get() {
        return this.selectedItems
      },
      set(value) {
        this.$emit('update:selected-items', value)
      },
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
      this.search = ''
    },
    isSelectedItem(item) {
      const allSelectedItems = this.localSelectedItems.map((item) => item.sku)
      return allSelectedItems.includes(item.sku)
    },
    selectItem(selectedItem) {
      if (this.isSelectedItem(selectedItem)) {
        const index = this.selectedItems.findIndex((item) => selectedItem.sku === item.sku)
        this.localSelectedItems.splice(index, 1)
      } else {
        this.localSelectedItems.push(selectedItem)
      }
    },
    link(param) {
      const route = this.$router.resolve({ path: `${this.linkUrl}${param}` })
      window.open(route.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-container {
  .dialog-title {
    color: $cinza-d10;
    font-size: 22px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: 0.01em;
    margin-bottom: 20px;
  }
  .dialog-description {
    color: #656565;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.4px;
  }
  .dialog-actions {
    display: flex;
    justify-content: flex-end;
  }
}
.img-container {
  width: 35px;
  height: 35px;

  & img {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
}
::v-deep .v-data-table .v-data-table__wrapper::-webkit-scrollbar {
  display: none;
}

::v-deep .v-data-table__wrapper {
  height: 50vh;
  overflow-y: auto !important;
}
</style>
